<template>
  <v-container class="carta-servicos">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form
        v-model="valid"
        ref="form"
      >
        <PageTitle
          main="Serviços"
          icon="mdi-pencil-box-outline"
          sub="Cadastro de Carta de Serviços"
          home="/servicos"
        />
        <input
          id="user-id"
          type="hidden"
          v-model="carta.usuario"
        />
        <input
          id="rgf-id"
          type="hidden"
          v-model="carta.id"
        />
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              dense
              outlined
            >
              <v-icon
                slot="append"
                color="success"
                large
                @click="loadDialog"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="codigo"
          >
            <v-checkbox
              v-model="carta.inativar"
              label="Inativar carta serviço?"
              color="success"
              v-show="mode === 'save'"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <v-checkbox
              v-model="carta.publicado"
              label="Publicar carta de serviço?"
              color="success"
              v-show="mode === 'save'"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-autocomplete
              v-model="carta.uid_categoria"
              :items="categorias"
              required
              dense
              outlined
              label="Categoria"
              @change="loadUnidades"
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-autocomplete
              v-model="carta.uid_pagina"
              :items="unidades"
              required
              dense
              outlined
              label="Unidade gestora"
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="dtp"
                  v-model="data_pub"
                  label="Data de publicação.:"
                  dense
                  outlined
                  @blur="mudaData"
                >
                  <v-icon
                    slot="append"
                    color="success"
                    large
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker
                locale="pt-br"
                v-model="date"
                @input="dateB"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="carta.ano"
              label="Ano da publicação"
              required
              dense
              outlined
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="9"
          >
            <v-text-field
              v-model="carta.titulo"
              label="Título"
              required
              dense
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <v-card class="pa-2">
              <ckeditor
                :editor="editor"
                v-model="carta.texto"
                :config="editorConfig"
                placeholder="Texto"
              ></ckeditor>
            </v-card>
          </v-col>
        </v-row>
        <v-card>
          <v-tabs
            background-color="primary"
            dark
            v-model="tabs"
          >
            <v-tab @click="loadAnexos">
              <v-icon class="mr-1">
                mdi-paperclip
              </v-icon>
              Anexos
            </v-tab>
            <v-tab @click="loadLinks">
              <v-icon class="mr-1">
                mdi mdi-link
              </v-icon>
              Links
            </v-tab>
            <v-tab @click="loadPerguntas">
              <v-icon class="mr-1">
                mdi mdi-order-bool-ascending-variant
              </v-icon>
              Perguntas e resp.
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersAnexos"
                        :items="anexos"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadAnexo(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-1 mb-3"
                            v-if="codigo"
                            @click="AddAnexo"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add anexo
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersLinks"
                        :items="links"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <a
                            :target="item.target"
                            rel="noopener"
                            :href="item.url"
                          >
                            <v-icon
                              medium
                              class="mr-2"
                            >
                               mdi-arrow-right-bold-box
                            </v-icon>
                          </a>
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadLink(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="confirmRemoveLink(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-1 mb-3"
                            v-if="codigo"
                            @click="AddLink"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add link
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersPerguntas"
                        :items="perguntas"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadPergunta(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="confirmRemovePrgt(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-1 mb-3"
                            v-if="codigo"
                            @click="AddPergunta"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add Pergunta
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row class="mt-1">
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              :disabled="!valid"
              color="success"
              class="ml-1 mr-4"
              v-if="mode === 'save'"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="mode === 'remove'"
              @click="remove"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar cartas de serviços
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="cartas"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadCarta(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                    <v-icon
                      medium
                      color="error"
                      class="mr-2"
                      @click="loadCarta(item, 'remove')"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialog.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog
          v-model="DialogAnexo"
          transition="dialog-top-transition"
        >
          <v-card
            class="py-4 px-2 auth-content"
            tile
          >
            <div class="logo-foto ml-4 mt-5">
              <v-form
                v-model="valid"
                ref="form"
                class="altura"
              >
                <PageTitle
                  v-if="anexo.id"
                  icon="mdi-pencil-box-outline"
                  :sub="`Anexo (${anexo.nome})`"
                />
                <PageTitle
                  v-else
                  icon="mdi-pencil-box-outline"
                  sub="Adicionar anexo"
                />
                <input
                  id="user-id"
                  type="hidden"
                  v-model="anexo.usuario"
                />
                <input
                  id="anexo-id"
                  type="hidden"
                  v-model="anexo.id"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="7"
                    lg="8"
                  >
                    <v-text-field
                      v-model="anexo.nome"
                      type="text"
                      label="Nome do arquivo"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    lg="4"
                  >
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-mask="datp"
                          v-model="date_pub"
                          label="Data de publicacao.:"
                          dense
                          outlined
                          @blur="mudaDataA"
                        >
                          <v-icon
                            slot="append"
                            color="success"
                            large
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt-br"
                        v-model="date1"
                        @input="dateA"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row v-if="mode === 'edit'">
                  <v-col cols="12" md="10" lg="10">
                    <v-text-field
                      v-if="!fileNovo"
                      :value="urlAnexo"
                      label="Arquivo atual"
                      outlined
                      dense
                      readonly
                      prepend-inner-icon="mdi-file"
                      hint="Arquivo atual anexado"
                      persistent-hint
                    >
                      <template v-slot:append>
                        <div class="botao-container">
                          <v-btn icon small @click="baixarArquivo()">
                            <v-icon>mdi-download</v-icon>
                          </v-btn>

                          <v-btn icon small @click="abrirInputTroca()">
                            <v-icon>mdi-file-replace</v-icon>
                          </v-btn>

                          <v-btn icon small color="red" @click="confirmRemove()">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </template>
                    </v-text-field>
                    <input
                      v-show="fileNovo"
                      type="file"
                      ref="fileTroca"
                      v-if="uploadReady"
                      dense
                      outlined
                      accept="application/pdf, application/vnd.ms-excel"
                      @change="handleTroca"
                    />
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12" md="6">
                    <v-file-input
                      label="Enviar anexo"
                      prepend-icon="mdi-file-upload"
                      dense
                      outlined
                      accept="application/pdf, application/vnd.ms-excel"
                      @change="handleUpload"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                class="mr-4"
                v-if="codigo && fileNovo"
                @click="clearUpload"
              >
                Remover
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="codigo && fileNovo"
                type="submit"
                @click.prevent="fileUpload()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="codigo && !fileNovo"
                @click="updateAnexo()"
              >
                <v-icon left>
                  mdi-update
                </v-icon>
                update
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="DialogLink"
          transition="dialog-top-transition"
        >
          <v-card
            class="py-4 px-2 auth-content"
            tile
          >
            <div class="logo-foto ml-4 mt-5">
              <v-form
                v-model="valid"
                class="altura"
              >
                <PageTitle
                  icon="mdi-pencil-box-outline"
                  sub="Adicionar link"
                />
                <input
                  id="user-id"
                  type="hidden"
                  v-model="link.usuario"
                />
                <input
                  id="link-id"
                  type="hidden"
                  v-model="link.id"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="7"
                    lg="8"
                  >
                    <v-text-field
                      v-model="link.nome"
                      type="text"
                      label="Nome do Link"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    lg="4"
                  >
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-mask="datp"
                          v-model="date_pub"
                          label="Data de publicacao.:"
                          dense
                          outlined
                          @blur="mudaDataA"
                        >
                          <v-icon
                            slot="append"
                            color="success"
                            large
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt-br"
                        v-model="date1"
                        @input="dateA"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="7"
                    lg="8"
                  >
                    <v-text-field
                      v-model="link.url"
                      type="text"
                      label="Url completa"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    lg="4"
                  >
                    <v-autocomplete
                      v-model="link.target"
                      :items="target"
                      label="Target"
                      outlined
                      dense
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="codigo"
                @click="saveLink"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="DialogPergunta"
          transition="dialog-top-transition"
          persistent
          :retain-focus="false"
        >
          <v-card
            class="py-4 px-2 auth-content"
            tile
          >
            <div class="ml-4 mt-5">
              <PageTitle
                icon="mdi-pencil-box-outline"
                sub="Adicionar pergunta e resposta"
              />
              <input
                id="user-id"
                type="hidden"
                v-model="pergunta.usuario"
              />
              <v-row>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="pergunta.id"
                    label="Código"
                    outlined
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-if="pergunta.id"
                >
                  <v-checkbox
                    v-model="pergunta.inativar"
                    label="Inativar pergunta ?"
                    color="success"
                  >
                  </v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-checkbox
                    v-model="pergunta.geral"
                    label="Visualizar na página de pergunas frequêntes ?"
                    color="success"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  lg="6"
                >
                  <v-text-field
                    label="Título:"
                    type="text"
                    v-model="pergunta.title"
                    outlined
                    dense
                 ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="5"
                  lg="4"
                >
                  <v-autocomplete
                    label="Pergunta Pai:"
                    :items="parent"
                    v-model="pergunta.parentId"
                    outlined
                    dense
                    hint="* Deixe em branco para criar a pergunta principal"
                    persistent-hint
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  lg="9"
                >
                  <v-text-field
                    label="Pergunta:"
                    type="text"
                    v-model="pergunta.pergunta"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card class="px-0 mb-2">
                    <v-card-title class="pl-2 my-0 pt-0 pb-1 text-subtitle-1 font-weight-regular">Resposta:</v-card-title>
                    <ckeditor
                      :editor="editor"
                      v-model="pergunta.resposta"
                      :config="editorConfig"
                      placeholder="Resposta"
                    ></ckeditor>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="codigo"
                @click="savePergunta"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
      <!-- Modal de confirmação -->
      <v-dialog v-model="dialogRmAnexo" max-width="400">
        <v-card>
          <v-card-title class="headline">
            Confirmar remoção
          </v-card-title>

          <v-card-text>
            Tem certeza de que deseja remover este anexo?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="grey" text @click="dialogRmAnexo = false">
              Cancelar
            </v-btn>

            <v-btn color="red" text @click="removeAnexoConfirmado">
              Remover
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Modal de confirmação -->
      <v-dialog v-model="dialogRmLink" max-width="400">
        <v-card>
          <v-card-title class="headline">
            Confirmar remoção
          </v-card-title>

          <v-card-text>
            Tem certeza de que deseja remover este Link?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="grey" text @click="dialogRmLink = false">
              Cancelar
            </v-btn>

            <v-btn color="red" text @click="removeLinkConfirmado">
              Remover
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Modal de confirmação -->
      <v-dialog v-model="dialogRmPrgt" max-width="400">
        <v-card>
          <v-card-title class="headline">
            Confirmar remoção
          </v-card-title>

          <v-card-text>
            Tem certeza de que deseja remover esta pergunta?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="grey" text @click="dialogRmPrgt = false">
              Cancelar
            </v-btn>

            <v-btn color="red" text @click="removePrgtConfirmado">
              Remover
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { baseApiUrl, showError } from '@/global'
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'CartaServicos',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    editor: ClassicEditor,
    editorConfig: {
    },
    dtp: '##/##/####',
    datp: '##/##/####',

    tabs: null,
    codigo: '',
    dialog: false,
    dialogRmLink: false,
    dialogRmPrgt: false,
    DialogAnexo: false,
    DialogLink: false,
    DialogPergunta: false,
    loading: false,
    uploadReady: true,
    dialogRmAnexo: false,
    anexoSelecionado: null,
    anexoRemover: null,
    file: null,
    fileNovo: null,
    section: 15,
    tabela: 'anexos_diversos',
    pasta: 'carta',
    search: null,
    select: null,
    date: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    data_pub: '',
    date_pub: '',
    menu: false,
    menu1: false,
    mode: 'save',
    carta: {},
    anexo: {},
    link: {},
    pergunta: {},
    parent: [],
    categorias: [],
    anexos: [],
    links: [],
    perguntas: [],
    cartas: [],
    unidades: [],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'titulo' },
      { text: 'Ano', value: 'ano' },
      { text: 'Publicação', value: 'data' },
      { text: 'Situação', value: 'inativar', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersAnexos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Tabela', value: 'tabela' },
      { text: 'Pasta', value: 'pasta' },
      { text: 'SubPasta', value: 'subpasta' },
      { text: 'Data', value: 'dtpub' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersLinks: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Url', value: 'url' },
      { text: 'Data', value: 'dtpub' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersPerguntas: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Título', value: 'title' },
      { text: 'pergunta', value: 'pergunta' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    target: [
      { value: '_top', text: '_top' },
      { value: '_parent', text: '_parent' },
      { value: '_self', text: '_self' },
      { value: '_blank', text: '_blank' }
    ],
    valid: false
  }),
  methods: {
    dateB () {
      this.data_pub = moment(this.date).format('DD/MM/YYYY')
      this.menu = false
    },
    mudaData () {
      const [dia, mes, ano] = this.data_pub.split('/')
      this.date = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateA () {
      this.date_pub = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
    },
    mudaDataA () {
      const [dia, mes, ano] = this.date_pub.split('/')
      this.date1 = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      this.anexo.data_publicacao = this.date1
    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      this.carta.publicacao = this.date
      const method = this.carta.id ? 'put' : 'post'
      const id = this.carta.id ? `/${this.carta.id}` : ''
      axios[method](`${baseApiUrl}/carta-de-servicos${id}`, this.carta)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    baixarArquivo () {
      window.open(this.urlAnexo, '_blank')
    },
    abrirInputTroca () {
      this.$refs.fileTroca.click()
    },
    handleTroca (e) {
      const file = e.target.files[0]
      if (file) {
        // this.mode = 'save'
        this.fileNovo = file
        this.file = file
        this.uploadReady = true
      }
    },
    handleUpload (file) {
      this.file = file
    },
    async fileUpload () {
      if (!this.file) {
        this.$toasted.global.defaultError('Selecione um arquivo')
        return
      }
      const formData = new FormData()
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      const url = `${baseApiUrl}/upload-documentos-em-anexo${id}`
      formData.append('idSection', this.carta.id)
      formData.append('section', this.section)
      formData.append('data_publicacao', this.date1)
      formData.append('nome', this.anexo.nome)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.pasta)
      formData.append('subpasta', this.carta.id)
      formData.append('usuario', this.anexo.usuario)
      formData.append('file', this.file)
      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
        })
        .catch(showError)
    },
    resetUpload () {
      this.file = null
      this.fileNovo = null
      this.anexo = {}
      if (this.$refs.fileTroca) this.$refs.fileTroca.value = null
    },
    clearUpload () {
      this.uploadReady = false
      this.file = null
      this.fileNovo = null
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    updateAnexo () {
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      this.anexo.tabela = this.tabela
      axios[method](`${baseApiUrl}/anexos-do-portal${id}`, this.anexo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.FecharDialog()
          this.loadAnexos()
        })
        .catch(showError)
    },

    saveLink () {
      const method = this.link.id ? 'put' : 'post'
      const id = this.link.id ? `/${this.link.id}` : ''
      axios[method](`${baseApiUrl}/links-diversos${id}`, this.link)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limpar()
          this.loadLinks()
        })
        .catch(showError)
    },

    savePergunta () {
      const method = this.pergunta.id ? 'put' : 'post'
      const id = this.pergunta.id ? `/${this.pergunta.id}` : ''
      axios[method](`${baseApiUrl}/perguntas-e-respostas${id}`, this.pergunta)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limpar()
          this.loadPerguntas()
        })
        .catch(showError)
    },

    // confirmRemove (item) {
    //   this.anexoSelecionado = item
    //   this.dialogRmAnexo = true
    // },
    confirmRemove (item) {
      this.anexoSelecionado = item || this.anexo
      this.dialogRmAnexo = true
    },
    confirmRemoveLink (item) {
      this.linkSelecionado = item
      this.dialogRmLink = true
    },
    confirmRemovePrgt (item) {
      this.prgtSelecionado = item
      this.dialogRmPrgt = true
    },
    removeAnexoConfirmado () {
      const id = this.anexoSelecionado.id
      this.anexo.tabela = this.anexoSelecionado.tabela
      const tabela = this.anexoSelecionado.tabela
      axios.delete(`${baseApiUrl}/upload-documentos-em-anexo/${id}`, {
        params: { tabela }
      })
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadAnexos()
        })
        .catch(showError)
        .finally(() => {
          this.dialogRmAnexo = false
          this.anexoSelecionado = null
        })
    },
    removeLinkConfirmado () {
      const id = this.linkSelecionado.id
      axios.delete(`${baseApiUrl}/links-diversos/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadLinks()
        })
        .catch(showError)
        .finally(() => {
          this.dialogRmLink = false
          this.linkSelecionado = null
        })
    },
    removePrgtConfirmado () {
      const id = this.prgtSelecionado.id
      axios.delete(`${baseApiUrl}/perguntas-e-respostas/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadPerguntas()
        })
        .catch(showError)
        .finally(() => {
          this.dialogRmPrgt = false
          this.prgtSelecionado = null
        })
    },
    loadAnexos () {
      const id = this.carta.id
      const section = this.section
      const url = `${baseApiUrl}/anexos-da-carta-de-servicos/${id}/section?section=${section}`
      axios.get(url).then(res => {
        this.anexos = res.data.map(item => {
          return {
            ...item,
            dtpub: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadLinks () {
      const id = this.carta.id
      const section = this.section
      const url = `${baseApiUrl}/links-da-carta-de-servicos/${id}/section?section=${section}`
      axios.get(url).then(res => {
        this.links = res.data.map(item => {
          return {
            ...item,
            dtpub: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadPerguntas () {
      const id = this.carta.id
      const section = this.section
      const url = `${baseApiUrl}/perguntas-da-carta-de-servicos/${id}/section?section=${section}`
      axios.get(url).then(res => {
        this.perguntas = res.data
      })
    },
    loadCategorias () {
      const url = `${baseApiUrl}/categorias`
      axios.get(url).then(res => {
        this.categorias = res.data.map(cat => {
          return {
            value: cat.id,
            text: cat.categoria
          }
        })
      })
    },
    loadUnidades (carta) {
      const id = carta.uid_categoria || this.carta.uid_categoria
      const url = `${baseApiUrl}/unidades-por-categoria/${id}`
      axios.get(url).then(res => {
        this.unidades = res.data.map(un => {
          return {
            value: un.id,
            text: un.unidade
          }
        })
      })
    },
    loadParent () {
      const url = `${baseApiUrl}/select-perguntas-e-respostas`
      axios.get(url).then(res => {
        this.parent = res.data.map(item => {
          return {
            value: item.id,
            text: item.pergunta
          }
        })
      })
    },
    loadCartas () {
      const url = `${baseApiUrl}/carta-de-servicos-filter`
      axios.get(url).then(res => {
        this.cartas = res.data.map(item => {
          return {
            ...item,
            data: moment(item.publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadCarta (carta, mode = 'save') {
      const id = carta.id
      this.mode = mode
      const url = `${baseApiUrl}/carta-de-servicos-update/${id}`
      axios.get(url).then(res => {
        this.carta = res.data
        this.codigo = this.carta.id
        this.data_pub = moment(carta.publicacao).format('DD/MM/YYYY')
        this.loadUnidades(carta)
      })
      this.dialog = false
      this.valid = true
      this.loadDatas()
    },
    loadAnexo (anexo, mode = 'edit') {
      this.mode = mode
      this.anexo = { ...anexo }
      this.anexo.usuario = this.user.id
      this.urlAnexo = anexo.url
      this.date_pub = moment(anexo.data_publicacao).format('DD/MM/YYYY')
      this.DialogAnexo = true
      this.loadDtAnexo()
    },
    AddAnexo () {
      this.anexo.usuario = this.user.id
      this.anexo.uid_carta = this.carta.id
      this.DialogAnexo = true
    },
    loadLink (link, mode = 'save') {
      this.mode = mode
      this.link = { ...link }
      this.link.usuario = this.user.id
      this.DialogLink = true
    },
    AddLink () {
      this.link.usuario = this.user.id
      this.link.idSection = this.carta.id
      this.link.section = this.section
      this.DialogLink = true
    },
    loadPergunta (pergunta, mode = 'save') {
      this.mode = mode
      this.pergunta = { ...pergunta }
      this.pergunta.usuario = this.user.id
      this.DialogPergunta = true
    },
    AddPergunta () {
      this.pergunta.usuario = this.user.id
      this.pergunta.uid_section = this.carta.id
      this.pergunta.section = this.section
      this.DialogPergunta = true
    },
    reset () {
      this.$refs.form.reset()
      this.valid = true
      this.mode = 'save'
      this.carta = {}
      this.anexos = []
      this.links = []
      this.anexo.usuario = this.user.id
      this.anexo.uid_carta = this.carta.id
      this.link.usuario = this.user.id
      this.link.idSection = this.carta.id
      this.link.section = this.section
      this.pergunta.usuario = this.user.id
      this.pergunta.uid_section = this.carta.id
      this.pergunta.section = this.section
      this.loadUser()
    },
    limpar () {
      this.mode = 'save'
      this.urlAnexo = ''
      this.anexo = {}
      this.link = {}
      this.pergunta = {}
      this.anexo.usuario = this.user.id
      this.anexo.uid_carta = this.carta.id
      this.link.usuario = this.user.id
      this.link.idSection = this.carta.id
      this.link.section = this.section
      this.pergunta.usuario = this.user.id
      this.pergunta.uid_section = this.carta.id
      this.pergunta.section = this.section
    },
    FecharDialog () {
      this.DialogAnexo = false
      this.DialogLink = false
      this.DialogPergunta = false
      this.limpar()
    },
    adicionarAnexo () {
      this.saveAnexo()
    },
    adicionarAnexoSair () {
      this.saveAnexo()
      this.DialogAnexo = false
    },
    loadDialog () {
      this.dialog = true
      this.loadCartas()
    },
    loadDatas () {
      this.mudaData()
    },
    loadDtAnexo () {
      this.mudaDataA()
      this.dateA()
    },
    loadUser () {
      this.carta.usuario = this.user.id
      this.carta.section = this.section
    }
  },
  mounted () {
    this.loadUser()
    this.loadCategorias()
    this.loadParent()
  }
}
</script>

<style scoped>
.altura {
  min-height: 380px !important;
}
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
  padding: auto !important;
  background-color: teal;
}
.v-icon-btn-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
.container {
  width: 98% !important;
}
.logo-foto {
  max-width: 1024px;
}
.botao-container {
  display: flex;
  align-items: center;
  gap: 4px;              /* espaço entre botões */
  background: #e0f2f1;
  margin-top: -7px !important;
  margin-right: -9px !important;
  padding: 6px 6px;
  border-radius: 6px;
}
</style>
